<btw-load-panel *ngIf="isUploadingInProgress" text="Uploading in progress..."></btw-load-panel>

<btw-dialog-body>
    <div class="btw-container">
        <div class="btw-row">
            <div class="btw-col">
                <form [formGroup]="form">
                    <btw-text-box 
                        formControlName="companyName" 
                        placeholder="Enter company name ...">
                        <btw-validator>
                            <btw-validation-rule errorType="required" message="Field is required."> </btw-validation-rule>
                        </btw-validator>
                    </btw-text-box>
                </form>
            </div>
        </div>
        <div class="btw-row">
            <div class="btw-col">
                <btw-file-uploader 
                    [uploadUrl]="uploadUrl"
                    [multiple]="true"
                    [allowedFileExtensions]="['.xml', '.txt']"
                    (onValueChanged)="handleFileUploaderValueChanged($event)"
                    (onBeforeSend)="handleBeforeSend($event)"/>
            </div>
        </div>
    </div>
</btw-dialog-body>

<btw-dialog-footer>
    <btw-button 
        appearance="secondary"
        text="Close" 
        [appBtwDialogClose] />
    
    <btw-button 
        text="Upload" 
        (onClick)="handleUpload()" />
</btw-dialog-footer>
